module.exports = __webpack_public_path__ + "img/7bit_logo.96488749.svg";